import React, { useEffect, useRef, useState } from "react";
import ModalDefault from "../../modalDefault";
import { DataTable } from "mantine-datatable";
import { toast } from "react-hot-toast";
import {
  ApiActivarDesactivarCargo,
  ApiGetAllCargos,
} from "../../../api/cargos";
import { ActionIcon, Group, TextInput } from "@mantine/core";

const BATCH_SIZE = 10;

const TablaCargos = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [allCargos, setAllCargos] = useState([]);
  const [filteredCargos, setFilteredCargos] = useState([]);
  const [fetching, setfetching] = useState(true);
  const [selectedCargo, setSelectedCargo] = useState(null);

  // Estados para scroll infinito y filtros
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadedRecords, setLoadedRecords] = useState(BATCH_SIZE);
  const [queryCargo, setQueryCargo] = useState("");
  const [queryCodigo, setQueryCodigo] = useState("");
  const scrollViewportRef = useRef(null);

  const columns = [
    {
      accessor: "pre_cargo",
      title: "Cargo",
      textAlignment: "center",
      filter: (
        <TextInput
          placeholder="Buscar por cargo..."
          value={queryCargo}
          onChange={(e) => setQueryCargo(e.currentTarget.value)}
        />
      ),
      filtering: queryCargo !== "",
    },
    {
      accessor: "pre_cod_cargo",
      title: "Código",
      textAlignment: "center",
      filter: (
        <TextInput
          placeholder="Buscar por código..."
          value={queryCodigo}
          onChange={(e) => setQueryCodigo(e.currentTarget.value)}
        />
      ),
      filtering: queryCodigo !== "",
    },
    {
      accessor: "acciones",
      title: "Acciones",
      textAlignment: "center",
      render: (record) => opciones(record),
    },
  ];

  useEffect(() => {
    init();
  }, [props.updateList]);

  const init = async () => {
    setfetching(true);
    const { data } = await ApiGetAllCargos();
    const filterCargos = data.filter((cargo) => cargo.estado !== false);
    setAllCargos(filterCargos);
    setFilteredCargos(filterCargos);
    setfetching(false);
  };

  // Logica para filtros
  useEffect(() => {
    const filtered = allCargos.filter((cargo) => {
      const matchCargo = cargo.pre_cargo
        .toLowerCase()
        .includes(queryCargo.toLowerCase());
      const matchCodigo = cargo.pre_cod_cargo
        .toLowerCase()
        .includes(queryCodigo.toLowerCase());

      return matchCargo && matchCodigo;
    });
    setFilteredCargos(filtered);
  }, [allCargos, queryCargo, queryCodigo]);

  // Carga más datos cuando se llega al final del scroll
  const loadMoreData = () => {
    if (loadedRecords < filteredCargos.length) {
      setLoadingMore(true);
      setTimeout(() => {
        setLoadedRecords(loadedRecords + BATCH_SIZE);
        setLoadingMore(false);
      }, 1000);
    }
  };

  const visibleCargos = filteredCargos.slice(
    0,
    Math.min(loadedRecords, filteredCargos.length)
  );

  const editCargo = (row) => {
    const { pre_cargo, pre_cod_cargo, pre_cargo_id } = row;
    props.setType("editar");
    props.setState({
      ...props.state,
      pre_cargo,
      pre_cod_cargo,
      pre_cargo_id,
    });
  };

  const onShowModal = (e) => {
    setShowModal(true);
    setSelectedCargo(e);
  };

  const onClosedModal = () => {
    setShowModal(false);
    setSelectedCargo(null);
  };

  const onDelete = async () => {
    const { estado, pre_cargo_id } = selectedCargo;
    const { sms, mensaje } = await ApiActivarDesactivarCargo({
      pre_cargo_id,
      pre_estado: !estado,
    });
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setSelectedCargo(null);
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    onClosedModal();
  };

  const opciones = (row) => {
    return (
      <Group spacing={4} position="center" noWrap>
        <ActionIcon
          color="blue"
          onClick={() => {
            editCargo(row);
          }}
        >
          <i className="fas fa-file-pen"></i>
        </ActionIcon>
        <ActionIcon
          color="red"
          onClick={() => {
            onShowModal(row);
          }}
        >
          <i className="fas fa-trash"></i>
        </ActionIcon>
        <ModalDefault
          bandera={"confirmacion"}
          modal={showModal}
          size={"sm"}
          icontitulo={<null />}
          titulo={`Confirmación`}
          closeAction={onClosedModal}
        >
          <div className="row py-4 justify-content-center text-align-center ">
            Realmente desea eliminar
          </div>
          <div className="d-flex justify-content-end flex-row align-self-start my-4">
            <button
              type=""
              onClick={onClosedModal}
              className="bg-btn-vet-danger sombra mx-1"
            >
              Cancelar
            </button>
            <button
              type=""
              onClick={onDelete}
              className="bg-btn-vet sombra mx-1"
            >
              <i className="fas fa-save"> Eliminar</i>
            </button>
          </div>
        </ModalDefault>
      </Group>
    );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <DataTable
          borderRadius="md"
          className="bordecompleto bgfondo "
          highlightOnHover
          noRecordsText="No se encontraron datos"
          columns={columns}
          totalRecords={allCargos.length}
          withColumnBorders
          records={visibleCargos}
          fetching={fetching || loadingMore}
          onScrollToBottom={loadMoreData}
          scrollViewportRef={scrollViewportRef}
          style={{ maxHeight: "350px", overflowY: "auto" }}
        />
      </div>
    </div>
  );
};

export default TablaCargos;
